import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './modules/shared-modules/shared.modules';
import { AppComponent } from './app.component';
import { PageService } from './services/page.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthGuardService } from './services/common_service/userAuthenticate.service';
import { ProfileSelectionModalComponent } from '../app/components/profile-selection-modal/profile-selection-modal.component';
import { SpinnerInterceptor } from './services/interceptors/spinner.interceptor';
import { LoaderComponent } from './components/loader/loader.component';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { AppLayoutComponent } from './layouts/app-layout/app-layout.component';
import { AuthorizationErrorComponent } from './pages/authorization-error/authorization-error.component';
import { LogoutComponent } from './pages/logout-page/logout/logout.component';

@NgModule({ declarations: [
        AppComponent,
        ProfileSelectionModalComponent,
        LoaderComponent,
        ErrorPageComponent,
        AppLayoutComponent,
        AuthorizationErrorComponent,
        LogoutComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        SharedModule,
        NgbModule], providers: [
        AuthGuardService,
        { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
        PageService,
        provideHttpClient(withInterceptorsFromDi())
    ] })

export class AppModule { }
